import { User as UserAuth } from 'firebase/auth';
import fetchWrapper from './fetchWrapper';
import { USER_ADMIN_API, WARDROBE_ADMIN_API } from '../config/ServiceConstants';
import { PushNotificationMessage } from '../models/PushNotificationMessage';

export function sendBatchPushNotification(userAuth: UserAuth, model: PushNotificationMessage): Promise<any> {
    const url = `${USER_ADMIN_API}/pnbatch`;
    return fetchWrapper(userAuth).post(url, model);
}